"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = require("query-string");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, null, function (p) {
    var search = (0, _queryString.parse)(p.location.search);
    if (search.filters) search.filters = JSON.parse(search.filters);
    return props.render(search);
  });
};

exports["default"] = _default;